var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 75,
    viewBox: "0 0 395 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.474 44.2726C117.326 47.5334 116.447 50.4127 114.835 52.9105C113.229 55.4084 110.971 57.3464 108.067 58.7184C105.163 60.0904 101.847 60.7795 98.1125 60.7795C91.9601 60.7795 87.112 58.7738 83.5744 54.7624C80.0367 50.7511 78.271 45.0909 78.271 37.7818V35.4685C78.271 30.8788 79.0708 26.8675 80.6643 23.4221C82.2639 19.983 84.5587 17.3251 87.5611 15.4487C90.5635 13.5722 94.0334 12.637 97.9832 12.637C103.662 12.637 108.233 14.132 111.685 17.1221C115.136 20.1122 117.099 24.2343 117.572 29.4884H106.314C106.227 26.6398 105.508 24.5911 104.16 23.3483C102.807 22.1055 100.752 21.4841 97.9832 21.4841C95.2147 21.4841 93.1167 22.5362 91.8063 24.6342C90.4958 26.7383 89.8129 30.0913 89.7514 34.6995V38.0095C89.7514 43.0052 90.3789 46.5736 91.634 48.7208C92.8891 50.868 95.0486 51.9385 98.1125 51.9385C100.709 51.9385 102.69 51.3294 104.062 50.1051C105.434 48.8807 106.166 46.9427 106.246 44.2849H117.468L117.474 44.2726Z",
    fill: "url(#paint0_linear_81_3723)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 60.1273C141.53 59.4198 141.191 58.38 140.89 57.008C138.897 59.5182 136.109 60.7733 132.529 60.7733C129.25 60.7733 126.463 59.7827 124.168 57.7955C121.873 55.8145 120.729 53.3227 120.729 50.3204C120.729 46.549 122.119 43.6942 124.906 41.7685C127.693 39.8428 131.747 38.8708 137.063 38.8708H140.41V37.0312C140.41 33.8197 139.026 32.2139 136.263 32.2139C133.692 32.2139 132.406 33.4874 132.406 36.0284H121.565C121.565 32.6692 122.999 29.9375 125.86 27.8395C128.72 25.7416 132.375 24.6895 136.811 24.6895C141.247 24.6895 144.754 25.7723 147.325 27.938C149.897 30.1036 151.22 33.0752 151.281 36.8466V52.2522C151.324 55.4453 151.817 57.894 152.758 59.5859V60.1334H141.917V60.1273ZM135.131 53.052C136.485 53.052 137.605 52.7629 138.49 52.1845C139.383 51.6062 140.016 50.9541 140.404 50.2219V44.6602H137.254C133.482 44.6602 131.594 46.3521 131.594 49.742C131.594 50.7264 131.926 51.5262 132.59 52.1353C133.255 52.7444 134.104 53.052 135.131 53.052Z",
    fill: "url(#paint1_linear_81_3723)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.321 35.1424L174.752 34.884C171.344 34.884 169.16 35.9545 168.194 38.1017V60.1334H157.354V25.3355H167.517L167.874 29.8083C169.695 26.3999 172.236 24.6956 175.497 24.6956C176.654 24.6956 177.663 24.8248 178.518 25.0832L178.327 35.1486L178.321 35.1424Z",
    fill: "url(#paint2_linear_81_3723)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.067 60.7733C193.727 60.7733 189.408 59.1798 186.104 55.999C182.8 52.8182 181.151 48.6715 181.151 43.5712V42.6729C181.151 39.1169 181.81 35.973 183.126 33.2475C184.443 30.5281 186.369 28.4178 188.897 26.929C191.426 25.4401 194.428 24.6956 197.904 24.6956C202.795 24.6956 206.653 26.2153 209.483 29.2484C212.313 32.2815 213.728 36.5144 213.728 41.9346V46.149H192.183C192.57 48.0993 193.413 49.6313 194.724 50.7449C196.028 51.8585 197.726 52.4183 199.805 52.4183C203.238 52.4183 205.915 51.2186 207.847 48.8192L212.799 54.6701C211.446 56.5343 209.532 58.0231 207.059 59.1244C204.586 60.2257 201.916 60.7794 199.067 60.7794V60.7733ZM197.843 33.0506C194.668 33.0506 192.786 35.1547 192.183 39.3568H203.115V38.5201C203.158 36.7851 202.722 35.4377 201.799 34.4841C200.876 33.5305 199.559 33.0506 197.843 33.0506Z",
    fill: "url(#paint3_linear_81_3723)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.816 42.4761C216.816 38.9631 217.394 35.8499 218.551 33.149C219.707 30.4482 221.368 28.3625 223.534 26.8921C225.7 25.4216 228.216 24.6895 231.089 24.6895C234.713 24.6895 237.543 25.9138 239.58 28.3563L239.967 25.3355H249.811V58.8168C249.811 61.8807 249.097 64.5447 247.67 66.8088C246.243 69.0728 244.182 70.8078 241.481 72.0198C238.78 73.2319 235.648 73.8348 232.092 73.8348C229.539 73.8348 227.072 73.3549 224.678 72.389C222.285 71.4231 220.458 70.168 219.197 68.6237L223.731 62.256C225.749 64.637 228.407 65.8244 231.704 65.8244C236.51 65.8244 238.909 63.3573 238.909 58.4292V57.3341C236.829 59.6289 234.202 60.7733 231.028 60.7733C226.783 60.7733 223.35 59.149 220.735 55.9006C218.12 52.6521 216.81 48.3085 216.81 42.8575V42.4699L216.816 42.4761ZM227.687 43.1467C227.687 45.9952 228.222 48.2532 229.293 49.9143C230.363 51.5755 231.864 52.406 233.796 52.406C236.134 52.406 237.838 51.6247 238.909 50.0558V35.4254C237.857 33.8381 236.177 33.0445 233.858 33.0445C231.926 33.0445 230.419 33.9058 229.324 35.6346C228.228 37.3634 227.681 39.8613 227.681 43.1467H227.687Z",
    fill: "url(#paint4_linear_81_3723)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M272.809 60.7733C267.469 60.7733 263.15 59.1798 259.846 55.999C256.542 52.8182 254.894 48.6715 254.894 43.5712V42.6729C254.894 39.1169 255.552 35.973 256.868 33.2475C258.185 30.5281 260.111 28.4178 262.639 26.929C265.168 25.4401 268.17 24.6956 271.647 24.6956C276.538 24.6956 280.395 26.2153 283.225 29.2484C286.055 32.2815 287.47 36.5144 287.47 41.9346V46.149H265.925C266.312 48.0993 267.155 49.6313 268.466 50.7449C269.77 51.8585 271.468 52.4183 273.548 52.4183C276.981 52.4183 279.657 51.2186 281.589 48.8192L286.541 54.6701C285.188 56.5343 283.275 58.0231 280.801 59.1244C278.328 60.2257 275.658 60.7794 272.809 60.7794V60.7733ZM271.585 33.0506C268.41 33.0506 266.528 35.1547 265.925 39.3568H276.858V38.5201C276.901 36.7851 276.464 35.4377 275.541 34.4841C274.618 33.5305 273.302 33.0506 271.585 33.0506Z",
    fill: "url(#paint5_linear_81_3723)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M301.787 25.3355L302.144 29.4207C304.543 26.2707 307.859 24.6956 312.08 24.6956C315.704 24.6956 318.411 25.7785 320.201 27.9441C321.991 30.1098 322.92 33.3705 322.982 37.7203V60.1334H312.111V38.1694C312.111 36.4098 311.754 35.1178 311.052 34.2934C310.345 33.469 309.059 33.0567 307.195 33.0567C305.072 33.0567 303.497 33.8935 302.47 35.5669V60.1396H291.629V25.3416H301.793L301.787 25.3355Z",
    fill: "url(#paint6_linear_81_3723)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M343.691 52.4122C345.211 52.4122 346.392 52 347.229 51.1756C348.066 50.3511 348.472 49.2006 348.453 47.7179H358.617C358.617 51.5324 357.251 54.664 354.513 57.1065C351.782 59.549 348.256 60.7733 343.95 60.7733C338.892 60.7733 334.899 59.186 331.983 56.0113C329.067 52.8367 327.609 48.4439 327.609 42.8268V42.3776C327.609 38.8646 328.255 35.7577 329.553 33.0691C330.851 30.3805 332.722 28.3071 335.164 26.8613C337.607 25.4155 340.504 24.6895 343.845 24.6895C348.367 24.6895 351.96 25.9446 354.618 28.4548C357.276 30.965 358.605 34.3611 358.605 38.6493H348.441C348.441 36.8466 348.004 35.4685 347.124 34.5026C346.244 33.5367 345.069 33.0568 343.587 33.0568C340.775 33.0568 339.138 34.8471 338.665 38.4278C338.517 39.566 338.437 41.1287 338.437 43.1221C338.437 46.6166 338.855 49.0407 339.692 50.388C340.529 51.7416 341.858 52.4122 343.679 52.4122H343.691Z",
    fill: "url(#paint7_linear_81_3723)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M380.033 60.7733C374.693 60.7733 370.374 59.1798 367.07 55.999C363.766 52.8182 362.117 48.6715 362.117 43.5712V42.6729C362.117 39.1169 362.775 35.973 364.092 33.2475C365.409 30.5281 367.334 28.4178 369.863 26.929C372.392 25.4401 375.394 24.6956 378.87 24.6956C383.761 24.6956 387.619 26.2153 390.449 29.2484C393.279 32.2815 394.694 36.5144 394.694 41.9346V46.149H373.148C373.536 48.0993 374.379 49.6313 375.689 50.7449C376.994 51.8585 378.692 52.4183 380.771 52.4183C384.204 52.4183 386.881 51.2186 388.812 48.8192L393.765 54.6701C392.412 56.5343 390.498 58.0231 388.025 59.1244C385.552 60.2257 382.882 60.7794 380.033 60.7794V60.7733ZM378.809 33.0506C375.634 33.0506 373.751 35.1547 373.148 39.3568H384.081V38.5201C384.124 36.7851 383.687 35.4377 382.765 34.4841C381.842 33.5305 380.525 33.0506 378.809 33.0506Z",
    fill: "url(#paint8_linear_81_3723)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4922 36.9328C24.4922 35.4193 24.7629 33.9181 25.3043 32.417C25.8457 30.9158 26.6455 29.5684 27.6976 28.381C28.7496 27.1874 30.0293 26.2276 31.5428 25.4955C33.0563 24.7634 34.7667 24.4004 36.6801 24.4004C38.9688 24.4004 40.9314 24.911 42.5618 25.9262C44.1921 26.9413 45.4165 28.2641 46.247 29.8945L43.1278 31.9863C42.7709 31.2295 42.3464 30.5958 41.8542 30.0729C41.3559 29.5561 40.8145 29.1377 40.2238 28.8301C39.6332 28.5225 39.018 28.3072 38.3843 28.1718C37.7444 28.0426 37.1292 27.9749 36.5447 27.9749C35.222 27.9749 34.0653 28.2395 33.0748 28.7747C32.0842 29.3038 31.2475 30.0114 30.5769 30.885C29.9063 31.7586 29.3956 32.7369 29.0511 33.8259C28.7066 34.9148 28.5405 35.9976 28.5405 37.0866C28.5405 38.3171 28.7435 39.4861 29.1434 40.5935C29.5433 41.7009 30.1032 42.6853 30.8291 43.5343C31.549 44.3834 32.4042 45.0663 33.3947 45.5708C34.3852 46.0814 35.4742 46.3337 36.6555 46.3337C37.2707 46.3337 37.8982 46.2598 38.5504 46.106C39.2026 45.9522 39.8239 45.7061 40.4269 45.3616C41.0298 45.0171 41.5835 44.5864 42.0942 44.0696C42.6048 43.5528 43.0232 42.9252 43.3493 42.1931L46.6469 44.0696C46.247 45.017 45.681 45.8476 44.9489 46.5675C44.2168 47.2873 43.3923 47.8964 42.4695 48.3947C41.5466 48.8931 40.5745 49.2684 39.5471 49.5268C38.5196 49.7852 37.5106 49.9144 36.5201 49.9144C34.7482 49.9144 33.1301 49.5391 31.6659 48.7823C30.2016 48.0256 28.9404 47.0412 27.876 45.823C26.8116 44.6048 25.9872 43.2267 25.3966 41.6763C24.806 40.1321 24.5106 38.5509 24.5106 36.9451L24.4922 36.9328Z",
    fill: "#3A5F89"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1294 43.7005C36.5449 43.7005 35.9666 43.6205 35.4067 43.4667L35.9297 41.5656C36.3173 41.6702 36.7233 41.7255 37.1294 41.7255C39.615 41.7255 41.6391 39.7014 41.6391 37.2158C41.6391 36.7667 41.5714 36.3299 41.4484 35.9054L43.331 35.3332C43.5156 35.9423 43.6079 36.576 43.6079 37.2158C43.6079 40.7904 40.7039 43.6943 37.1294 43.6943V43.7005Z",
    fill: "#3A5F89"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8052 38.637C30.7006 38.1756 30.6514 37.6957 30.6514 37.222C30.6514 33.6475 33.5553 30.7435 37.1298 30.7435C37.6405 30.7435 38.145 30.8051 38.631 30.9219L38.1757 32.8353C37.8374 32.7554 37.4805 32.7123 37.1298 32.7123C34.6443 32.7123 32.6201 34.7364 32.6201 37.222C32.6201 37.5542 32.657 37.8865 32.7309 38.2064L30.8113 38.637H30.8052Z",
    fill: "#3A5F89"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3802 28.7071C47.19 25.8893 45.1043 24.3943 41.5913 22.9977L42.8156 18.2726C47.4238 19.4662 50.7584 21.9333 53.4839 25.8524L49.3802 28.7071Z",
    fill: "#3A5F89"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0324 37.8556L52.0366 37.7018C52.0366 37.5418 52.0428 37.3819 52.0428 37.2219C52.0428 34.441 51.2737 31.7278 49.8218 29.3776L54.0731 26.7444C56.0172 29.8883 57.0447 33.5059 57.0447 37.2158C57.0447 37.4249 57.0447 37.6403 57.0324 37.8494V37.8556Z",
    fill: "url(#paint9_linear_81_3723)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3522 54.8855L44.0327 50.4558C46.3337 49.2499 48.2902 47.4534 49.6991 45.2632L53.9073 47.9579C52.037 50.8803 49.4222 53.2736 46.3522 54.8855Z",
    fill: "#3A5F89"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1118 57.1557C35.2353 57.1557 33.3773 56.8973 31.5869 56.3805L32.9712 51.5755C34.3124 51.9631 35.7029 52.1538 37.1118 52.1538C39.5173 52.1538 41.806 51.6001 43.9286 50.5111L46.2173 54.9593C43.4241 56.3928 40.2741 57.1557 37.1179 57.1557H37.1118Z",
    fill: "url(#paint10_linear_81_3723)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4387 56.3313C26.6275 54.9039 22.5608 51.7354 19.9829 47.4103L24.2773 44.8509C26.2091 48.0932 29.2607 50.4681 32.8599 51.5386L31.4387 56.3313Z",
    fill: "#3A5F89"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8417 47.1827C18.1006 44.168 17.1777 40.7226 17.1777 37.2219C17.1777 37.0743 17.1777 36.9266 17.1777 36.779L22.1796 36.8836C22.1796 36.9943 22.1796 37.105 22.1796 37.2219C22.1796 39.8429 22.8687 42.4207 24.173 44.6786L19.8417 47.1827Z",
    fill: "url(#paint11_linear_81_3723)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3691 29.433L20.1055 26.8183C21.9881 23.7421 24.6705 21.2319 27.8636 19.5584L30.1892 23.9882C27.796 25.2432 25.7841 27.1259 24.3752 29.433H24.3691Z",
    fill: "#3A5F89"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7136 23.7297L28.5664 19.2139C31.2488 17.9403 34.122 17.2943 37.1121 17.2943C38.7548 17.2943 40.3913 17.4973 41.9786 17.8911L40.7604 22.7392C39.573 22.4439 38.3487 22.2901 37.1121 22.2901C34.8726 22.2901 32.7193 22.7761 30.7136 23.7297Z",
    fill: "url(#paint12_linear_81_3723)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7638 24.3942C49.0411 22.5485 47.0109 21.0904 44.7222 20.0568L46.654 15.7686C49.5149 17.0606 52.0558 18.8817 54.203 21.1888L50.7638 24.3942Z",
    fill: "#3A5F89"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.697 35.1363C55.2602 31.1864 53.6175 27.5381 50.9351 24.5849L54.4173 21.4226C57.7704 25.114 59.8314 29.6791 60.3728 34.6195L55.697 35.1363Z",
    fill: "url(#paint13_linear_81_3723)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9825 58.0232L45.7861 53.8703C50.302 51.4771 53.6981 47.2996 55.0947 42.4023L59.6167 43.6943C57.8694 49.8159 53.6304 55.0393 47.9887 58.0232H47.9825Z",
    fill: "url(#paint14_linear_81_3723)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9938 60.7364C34.0591 60.7364 31.1983 60.2012 28.4912 59.1491L30.1893 54.7686C32.3549 55.6115 34.6436 56.036 36.9938 56.036C40.0454 56.036 43.0785 55.2916 45.7548 53.8765L47.9451 58.0355C44.592 59.8013 40.8021 60.7364 36.9877 60.7364H36.9938Z",
    fill: "url(#paint15_linear_81_3723)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2092 59.0445C24.6532 57.611 21.4601 55.2977 18.9868 52.3446L22.586 49.3176C24.567 51.6801 27.1203 53.532 29.9688 54.6763L28.2092 59.0384V59.0445Z",
    fill: "url(#paint16_linear_81_3723)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6545 51.9446C15.7691 48.3578 14.0156 44.0388 13.585 39.4614L18.2669 39.0184C18.6115 42.6791 20.0142 46.1244 22.3214 48.9976L18.6545 51.9446Z",
    fill: "url(#paint17_linear_81_3723)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.091 31.4141L14.6182 29.9622C16.55 24.0128 20.869 18.9863 26.48 16.1808L28.5841 20.3829C24.0928 22.6285 20.6352 26.6522 19.091 31.408V31.4141Z",
    fill: "url(#paint18_linear_81_3723)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7034 20.0506C42.2732 18.9616 39.6831 18.4079 36.9945 18.4079C35.1303 18.4079 33.2907 18.6786 31.525 19.2139L30.1592 14.7165C32.3679 14.0459 34.6689 13.7075 36.9945 13.7075C40.3475 13.7075 43.5898 14.4027 46.6291 15.7685L44.7034 20.0568V20.0506Z",
    fill: "url(#paint19_linear_81_3723)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9985 15.947C43.8485 14.4519 40.4646 13.6952 36.9455 13.6952C34.7491 13.6952 32.5773 13.9967 30.4855 14.5935L28.8735 8.93941C31.4883 8.19497 34.2015 7.81967 36.9393 7.81967C41.3321 7.81967 45.565 8.76714 49.5087 10.6313L46.9923 15.947H46.9985Z",
    fill: "url(#paint20_linear_81_3723)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0979 21.115C52.0861 18.974 49.7297 17.2451 47.0903 15.9839L49.6313 10.6805C52.9289 12.2617 55.8759 14.415 58.3861 17.0913L54.1041 21.115H54.0979Z",
    fill: "url(#paint21_linear_81_3723)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3123 34.4965C59.7463 29.5869 57.6791 25.0525 54.3384 21.3857L58.682 17.4236C62.8594 22.0071 65.4434 27.6796 66.151 33.8259L60.3123 34.4965Z",
    fill: "url(#paint22_linear_81_3723)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6896 60.6688L51.1396 55.9806C57.0706 51.4894 60.4728 44.6479 60.4728 37.2158C60.4728 36.3422 60.4236 35.4624 60.3313 34.6011L66.1761 33.9551C66.293 35.0317 66.3545 36.1269 66.3545 37.2158C66.3545 41.8978 65.284 46.3706 63.1799 50.5173C61.1742 54.4671 58.2395 57.9802 54.6957 60.6626L54.6896 60.6688Z",
    fill: "url(#paint23_linear_81_3723)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9462 66.6243C26.3579 66.6243 16.5387 60.8902 11.3276 51.6616L16.4464 48.77C20.6177 56.1529 28.4743 60.7426 36.9462 60.7426C41.2344 60.7426 45.4242 59.5798 49.0726 57.3772L52.1057 62.4099C47.5406 65.16 42.2988 66.6181 36.94 66.6181L36.9462 66.6243Z",
    fill: "url(#paint24_linear_81_3723)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90598 48.7885C8.33712 45.1278 7.54346 41.2333 7.54346 37.222C7.54346 34.0966 8.03565 31.0142 8.99542 28.0672L14.5818 29.8945C13.8127 32.2508 13.419 34.7179 13.419 37.222C13.419 40.4335 14.0527 43.5466 15.3078 46.4752L9.90598 48.7885Z",
    fill: "url(#paint25_linear_81_3723)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6366 29.7283L9.0625 27.858C12.1079 18.7832 19.4047 11.7388 28.584 9.01941L30.2513 14.655C22.9115 16.8268 17.0729 22.4624 14.6366 29.7283Z",
    fill: "url(#paint26_linear_81_3723)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8289 66.0828L56.27 60.5026C60.8474 56.762 64.1266 51.8031 65.7447 46.1552L72.6661 48.1425C70.642 55.2054 66.5445 61.407 60.8228 66.0828H60.8289Z",
    fill: "url(#paint27_linear_81_3723)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M36.779 74.7392C31.5372 74.7392 26.4799 73.6379 21.7549 71.4661L24.7634 64.92C28.541 66.655 32.5831 67.5348 36.779 67.5348C42.3654 67.5348 47.7795 65.9351 52.443 62.9143L56.3621 68.956C50.5296 72.7397 43.7558 74.7392 36.779 74.7392Z",
    fill: "url(#paint28_linear_81_3723)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1151 71.0355C16.9684 69.0483 13.2831 66.3167 10.1577 62.9205L15.4549 58.0417C17.9589 60.761 20.9121 62.9451 24.2282 64.5386L21.1151 71.0355Z",
    fill: "url(#paint29_linear_81_3723)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2196 66.3966C19.6881 64.7047 16.5504 62.3791 13.8926 59.4936L18.4023 55.3408C20.531 57.6541 23.0473 59.5121 25.8713 60.8718L23.2196 66.3966Z",
    fill: "url(#paint30_linear_81_3723)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77443 51.3847C1.2794 47.8717 0.356545 44.1495 0.0366211 40.3227L7.21646 39.7136C7.47486 42.7775 8.21315 45.7553 9.40671 48.5608L2.78059 51.3786L2.77443 51.3847Z",
    fill: "url(#paint31_linear_81_3723)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1905 33.752C64.4091 28.1287 61.9974 22.893 58.2075 18.6171L63.597 13.8367C68.3344 19.177 71.349 25.7231 72.3273 32.7615L65.1905 33.7458V33.752Z",
    fill: "url(#paint32_linear_81_3723)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2817 27.495L0.880371 24.8864C2.54152 20.1798 5.05784 15.8732 8.35553 12.1017C11.6532 8.33033 15.5723 5.26644 20.0082 2.99005L23.5888 9.97301C16.4029 13.6583 10.9641 19.8845 8.27554 27.495H8.2817Z",
    fill: "url(#paint33_linear_81_3723)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9611 10.3299C45.0789 8.68105 40.9507 7.84433 36.6932 7.84433C34.2261 7.84433 31.7713 8.13349 29.3965 8.69336L27.5815 1.06439C30.5531 0.356869 33.617 3.05176e-05 36.6932 3.05176e-05C42.0089 3.05176e-05 47.1708 1.04594 52.025 3.11314L48.9549 10.336L48.9611 10.3299Z",
    fill: "url(#paint34_linear_81_3723)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2416 17.3989C56.3623 14.4273 52.9846 12.0833 49.207 10.4406L52.3386 3.24844C57.0636 5.30334 61.278 8.23188 64.8772 11.9418L59.2416 17.3989Z",
    fill: "url(#paint35_linear_81_3723)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1065 39.8489C38.6865 39.8489 39.9673 38.5681 39.9673 36.9881C39.9673 35.4081 38.6865 34.1272 37.1065 34.1272C35.5265 34.1272 34.2456 35.4081 34.2456 36.9881C34.2456 38.5681 35.5265 39.8489 37.1065 39.8489Z",
    fill: "#3A5F89"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_81_3723",
    x1: 78.271,
    y1: 43.2267,
    x2: 394.695,
    y2: 43.2267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_81_3723",
    x1: 78.2709,
    y1: 43.2267,
    x2: 394.694,
    y2: 43.2267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_81_3723",
    x1: 78.2707,
    y1: 43.2266,
    x2: 394.694,
    y2: 43.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_81_3723",
    x1: 78.2712,
    y1: 43.2266,
    x2: 394.695,
    y2: 43.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_81_3723",
    x1: 78.27,
    y1: 43.2267,
    x2: 394.694,
    y2: 43.2267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_81_3723",
    x1: 78.2707,
    y1: 43.2266,
    x2: 394.694,
    y2: 43.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_81_3723",
    x1: 78.2708,
    y1: 43.2266,
    x2: 394.694,
    y2: 43.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_81_3723",
    x1: 78.2709,
    y1: 43.2267,
    x2: 394.695,
    y2: 43.2267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_81_3723",
    x1: 78.2708,
    y1: 43.2266,
    x2: 394.694,
    y2: 43.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_81_3723",
    x1: 49.8218,
    y1: 32.3,
    x2: 57.0447,
    y2: 32.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_81_3723",
    x1: 31.5869,
    y1: 53.8334,
    x2: 46.2173,
    y2: 53.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_81_3723",
    x1: 17.1839,
    y1: 41.9777,
    x2: 24.173,
    y2: 41.9777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_81_3723",
    x1: 28.5664,
    y1: 20.5059,
    x2: 41.9786,
    y2: 20.5059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_81_3723",
    x1: 61.9355,
    y1: 25.1755,
    x2: 51.2242,
    y2: 31.8878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_81_3723",
    x1: 52.6091,
    y1: 42.4761,
    x2: 52.9783,
    y2: 69.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_81_3723",
    x1: 48.7756,
    y1: 53.0829,
    x2: 31.7827,
    y2: 59.1184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_81_3723",
    x1: 18.9868,
    y1: 54.178,
    x2: 29.9688,
    y2: 54.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_81_3723",
    x1: 13.585,
    y1: 45.4784,
    x2: 22.3214,
    y2: 45.4784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_81_3723",
    x1: 14.6182,
    y1: 23.7975,
    x2: 28.5841,
    y2: 23.7975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_81_3723",
    x1: 30.1592,
    y1: 16.876,
    x2: 46.6291,
    y2: 16.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_81_3723",
    x1: 39.8371,
    y1: 3.87599,
    x2: 37.8683,
    y2: 21.9763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_81_3723",
    x1: 47.0842,
    y1: 15.9039,
    x2: 58.38,
    y2: 15.9039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_81_3723",
    x1: 56.9593,
    y1: 18.0511,
    x2: 64.2253,
    y2: 36.0284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_81_3723",
    x1: 58.3749,
    y1: 44.1311,
    x2: 64.9456,
    y2: 63.9972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_81_3723",
    x1: 46.6916,
    y1: 64.151,
    x2: 16.2803,
    y2: 53.5627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_81_3723",
    x1: 9.99826,
    y1: 25.1756,
    x2: 12.5884,
    y2: 47.7118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_81_3723",
    x1: 9.0625,
    y1: 19.38,
    x2: 30.2513,
    y2: 19.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_81_3723",
    x1: 56.27,
    y1: 56.1221,
    x2: 72.6661,
    y2: 56.1221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_81_3723",
    x1: 21.7549,
    y1: 68.8206,
    x2: 56.3682,
    y2: 68.8206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_81_3723",
    x1: 10.2131,
    y1: 64.8105,
    x2: 24.2209,
    y2: 64.3556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_81_3723",
    x1: 21.5215,
    y1: 61.7269,
    x2: 10.1888,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_81_3723",
    x1: 0.0366211,
    y1: 45.5522,
    x2: 9.40671,
    y2: 45.5522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_81_3723",
    x1: 58.0635,
    y1: 23.6051,
    x2: 72.6068,
    y2: 24.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_81_3723",
    x1: 0.886523,
    y1: 15.2456,
    x2: 23.595,
    y2: 15.2456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_81_3723",
    x1: 27.5815,
    y1: 5.16804,
    x2: 52.025,
    y2: 5.16804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_81_3723",
    x1: 49.207,
    y1: 10.3237,
    x2: 64.8772,
    y2: 10.3237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.67837685ca6ae1d2035440881200da1b.svg";
export { ForwardRef as ReactComponent };